import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { NominatimResponse } from 'src/app/shared/models/api-response/nominatim-response';
import {
	CompetenceSSIAD,
	CompetenceSESSAD,
	CompetenceSAAD,
	CompetenceElementaireSESSAD,
	getCompetenceElementaireFromCompetence,
	getMultipleCompetenceFromListCompetenceElementaire,
	CompetenceElementaireSSIAD
} from 'src/app/shared/enums/competence.enum';
import { Employee } from 'src/app/shared/models/employee/employee';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_USER
} from 'src/app/core/services/constant/constants.service';
import { ServiceCenter } from 'src/app/shared/models/service-center';
import {
	AbstractControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn,
	Validators
} from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { Observable, of, Subscriber } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { Profile } from 'src/app/shared/models/security/profile';
import { Permission } from 'src/app/shared/models/security/permission';

@Component({
	selector: 'app-role-form',
	templateUrl: './role-form.component.html',
	styleUrls: ['./role-form.component.scss']
})
export class RoleFormComponent implements OnInit {
	/**
	 * Role
	 */
	@Input() role: Profile;

	/**
	 * Vrai si formulaire d'ajout, faux sinon (formulaire de détail)
	 */
	@Input() isAddForm: boolean;

	/**
	 * Addresse sélectionner dans le typeahead
	 */
	@Input() isAddressSelected: { value: boolean };

	/**
	 * Booleen indiquant si il s'agit de l'addresse par défaut ou non
	 */
	@Input() isAddressDefault: { value: boolean };

	/**
	 * Formulaire angular
	 */
	@Input() form: FormGroup;

	/**
	 * Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	 */
	@Input() isValidateButtonClicked: { value: boolean };

	/**
	 * Signal émis lors de l'envoi du formulaire pour que la sauvegarde du formulaire ce fasse dans le composant parent
	 */
	@Output() sendForm: EventEmitter<any> = new EventEmitter();

	/**
	 * Signal émis pour que la modal soit fermée
	 */
	@Output() hideModal: EventEmitter<any> = new EventEmitter();

	LABEL_USER: string;
	MAX_NAME_CHAR = 25;

	/**
	 * Typeahead des adresse en chargement
	 */
	typeaheadLoading?: boolean;



	/**
	 * Liste des rôles
	 */
	listProfile: Profile[];
	listProfileMapped = []; // list pour le typeahead sous forme {name:nom_employee,object:employee}

	listProfiles: Profile[] = [];

	listPermission: Permission[];
	listSelectedPermission: Permission[];

	constructor(
		private facade: FacadeService,
		private logger: LogService,
		private cache: CacheService
	) {
		
	}

	ngOnInit(): void {
		if (this.role) {
			this.getAllProfilesAndSetProfilesInForm();

			this.facade.permissionService.getAllPermissions().subscribe({
				next: (val) => {
					this.listPermission = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
		}

		this.facade.permissionService.getAllPermissions().subscribe({
			next: (val) => {
				this.listPermission = val;
			},
			error: (err) => {
				this.logger.error(err);
			}
		});

		this.listSelectedPermission = [...this.role.permissions];
	}

	isPermissionCheck(spec: Permission): boolean {
		return this.listSelectedPermission?.some(
			(specItfc) => specItfc.id === spec.id
		);
	}

	/**
	 * Ajoute ou supprime la spécialité à la liste des spécialités sélectionnées
	 * @param e Element html
	 * @param spe String representant la permission choisie
	 */
	updateSelectedPermission(e: any, spe: Permission) {
		if (e.target.checked) {
			if (!this.listSelectedPermission.some((z) => z.id === spe.id)) {
				this.listSelectedPermission.push(spe);
			}
		} else {
			if (this.listSelectedPermission.some((z) => z.id === spe.id)) {
				this.listSelectedPermission = this.listSelectedPermission.filter(
					(z) => z.id !== spe.id
				);
			}
		}
	}

	changeTypeaheadLoading(e: boolean): void {
		this.typeaheadLoading = e;
	}

	/**
	 * Méthode d'envoie de formulaire, si celui est valide stock les données et envoie un signal au composant parent
	 */
	submitForm() {
		if (this.form.valid) {
			this.role.name = this.form.value.name;
			this.role.description = this.form.value.description;
			if (this.listSelectedPermission.length >= 2) {
				this.listSelectedPermission = this.listSelectedPermission.filter(
					(e) => e.libelle !== 'Sans'
				);
			}
			this.role.permissions = this.listSelectedPermission;
			this.sendForm.emit();
		}
	}

	get name() {
		return this.form?.get('name');
	}
	get description() {
		return this.form?.get('description');
	}

	isAddressValidValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			return !(this.isAddressDefault.value || this.isAddressSelected.value)
				? { invalidAddress: { value: control.value } }
				: null;
		};
	}

	profileKeyUp(e: any, position: number) {
		if (this.listProfiles[position - 1] &&
			this.listProfiles[position - 1].id !==
				e.value
		) {
			this.listProfiles[position - 1] = null;
		}
	} 

	typeaheadProfileOnSelect(
		event: TypeaheadMatch,
		position: number
	): void {
			const profileToSet = event.item.object as Profile;
			if (
				this.listProfiles.findIndex(
					(profile) => profile && profile.id === profileToSet.id
				) === -1 )
			 {
				this.listProfiles[position - 1] = profileToSet;
				if (position === 1) {
					this.form.patchValue(
						{ profile: event.item.name },
						{ onlySelf: true }
					);
			} 
		}
	
	}

	getAllProfilesAndSetProfilesInForm() {
		this.facade.profileService.getAllProfiles().subscribe((data) => {
			this.listProfile = data;
			this.listProfileMapped = data.flatMap((e) => {
				return { name: e.name , object: e };
			});
			if (!this.isAddForm) {
				/**
				 * Récupère les données et initialise le formulaire
				 */
				this.form.patchValue({
					name: this.role.name,
					description: this.role.description,
				});
			}
		});
	}

}
